import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import DocumentIntakePage from "@/pages/admin/DocumentIntakePage";

export const Route = createFileRoute("/_admin/admin/document-intake")({
  head: () => pageHead("Admin · Document Intake", "AKIVA admin · document intake portal.", "/admin/document-intake", true),
  component: DocumentIntakePage,
});
